import Vue from 'vue';
import Router from 'vue-router';
import routerPermission from './permission';
import layout from '@/views/home/index.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/game/page/game',
    },
    {
      path: '/',
      component: layout,
      children: [
        {
          path: '/game/page/:alias',
          name: 'gamePage',
          component: () => import('@/views/game/page.vue'),
        },
      ],
    },
  ],
});

router.beforeEach(routerPermission);

export default router;
